/**
 * A regex object to validate latitudes
 */
export const LATITUDE_REGEX = /^[-+]?(?:[1-8]?\d(?:\.\d+)?|90(\.0+)?)$/;
